module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/engine.io-client/~/engine.io-parser/~/has-binary/~/isarray/index.js
// module id = 30
// module chunks = 0